import { DateFormatters, NumberFormatters } from './formatters';

export class CSVUtils {
    static regexDate = /\b[0-9]{4}-[0-9]{2}-[0-9]{2}\b/;

    static generateCsv(data, noHeader = false, replaceHeader = null) {
        if (data.length === 0) {
            return [];
        }
        data = data.map(el => {
            // Converte as ocorrencias de valores estrangeiros para o padrão brasileiro
            if (typeof el === 'object') {
                const ret = {};
                Object.keys(el).forEach(key => {
                    const item = el[key];
                    if (typeof item === 'number') {
                        if (!Number.isInteger(item)) {
                            ret[key] = NumberFormatters.f2ptbr2.format(item);
                        }
                        ret[key] = item;
                    } else if (
                        typeof item === 'string' &&
                        item.match(CSVUtils.regexDate)
                    ) {
                        ret[key] = DateFormatters.str2ptbrDate(item);
                    } else {
                        ret[key] = item;
                    }
                });
                return ret;
            }

            return el;
        });

        const replacer = (key, value) => (value === null ? '-' : value); // specify how you want to handle null values here
        const header = Object.keys(data[0]);
        const csv = data.map(row =>
            header
                .map(fieldName => JSON.stringify(row[fieldName], replacer))
                .join(',')
        );
        csv.push(['']);
        csv.unshift(noHeader ? [''] : (replaceHeader || header).join(','));
        return csv;
    }
}
